export default __webpack_public_path__ + "static/icon-11-5-d39edbbc545eba9e04c3be0cc3b665fd.png";